/**
 * OVERVIEW-RESTRUCTURE-1 — Project Governance tab.
 * Oversight surface: Phases & Gates (with milestone markers) + open exceptions.
 * Working-surface Overview keeps only the header Governed badge as its signal.
 */

import React from 'react';
import { useParams } from 'react-router-dom';

import { useProjectContext } from '../layout/ProjectPageLayout';
import { ProjectOverviewPhaseGateStrip } from '../components/ProjectOverviewPhaseGateStrip';
import { ProjectOverviewExceptions } from '../components/ProjectOverviewExceptions';

export const ProjectGovernanceTab: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const {
    project,
    projectPlan,
    planLoadError,
    refreshProjectPlan,
  } = useProjectContext();
  const workspaceId = project?.workspaceId ?? '';

  if (!projectId) return null;

  return (
    <div className="space-y-5" data-testid="project-governance-tab">
      <ProjectOverviewPhaseGateStrip
        projectId={projectId}
        plan={projectPlan}
        planLoadError={planLoadError}
        onRetryPlan={() => void refreshProjectPlan()}
      />

      {workspaceId ? (
        <ProjectOverviewExceptions projectId={projectId} workspaceId={workspaceId} />
      ) : null}
    </div>
  );
};

export default ProjectGovernanceTab;
